import { render, staticRenderFns } from "./DashboardGrossProfit.vue?vue&type=template&id=2e390078&scoped=true&"
import script from "./DashboardGrossProfit.vue?vue&type=script&lang=js&"
export * from "./DashboardGrossProfit.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGrossProfit.vue?vue&type=style&index=0&id=2e390078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e390078",
  null
  
)

export default component.exports